import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { getCookie } from '@/utils/auth'
// 创建axios实例
const service = axios.create({
    baseURL: `http://lianlianche.qicp.vip:9000`, // api的base_url
    timeout: 15000, // 请求超时时间2
    headers: {
        "X-token": getCookie('token'),
        "X-uid": getCookie('uid'),
        "X-store": getCookie('storeId'),
        // "X-departmentId": getCookie("deptId")
    }
})


// // 创建axios实例
// export const bbsApi = axios.create({
//   baseURL: process.env.BASE_URL_BBS, // api的base_url
//   timeout: 15000,                  // 请求超时时间2
//   headers: {
//     'X-uid': "collect_token",
//     'X-token': "collect_token",
//     "Content-Type": "application/json;charset=UTF-8"
//   },
// })

// request拦截器
service.interceptors.request.use(config => {

        // cancelPending(config)
        // config.cancelToken = new CancelToken(res => {
        //   pending.push({'UrlPath': config.url, 'Cancel': res})
        // })

        return config
    }, error => {
        // Do something with request error
        console.error(error) // for debug
        Promise.reject(error)
    })
    // respone拦截器
service.interceptors.response.use(
    response => {
        // cancelPending(response.config)
        const res = response.data;
        getCookie('uid')
        if (res.status == 0) {
            return res;
        } else if (res.status == 600) {
            Message({
                showClose: true,
                message: res.msg,
                type: 'error',
                duration: 500,
                onClose: () => {
                    store.dispatch('FedLogOut').then(() => {
                        location.reload() // 为了重新实例化vue-router对象 避免bug
                    })
                }
            });
            return Promise.reject("未登录")
                // return res
        } else {
            Message({
                message: res.msg,
                type: 'error',
                duration: 3 * 1000
            })
            return res
        }
    },
    error => {
        console.error('err' + error) // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 3 * 1000
        })
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/api.js